import { Checkbox, Flex, FormControl, Text, VStack } from '@chakra-ui/react';

import { useLibraryFilters } from '@/components/ui/features/library/LibraryFilter/LibraryFilter.hooks';
import { useAnalytics } from '@/context/Analytics';
import { LibraryFilter } from '@/enums/LibraryFilter';
import { useLibLynx } from '@/hooks/useLibLynx';
import { useQueryParams } from '@/hooks/useQueryParams';
import { useResource, useResourceRelationship } from '@/lib/datx-jsonapi-react';
import { getHubBySlug, getHubsSubtree } from '@/queries/hubs';
import { queryOmnisearchThinLectureFiltersRelationship } from '@/queries/omnisearch-thin-lectures';
import { StringArrayParams, StringParam } from '@/utils/url-query-string';

export const FilterReleaseYear = () => {
  const analytics = useAnalytics();
  const libLynx = useLibLynx();

  const { filters, change } = useLibraryFilters({
    [LibraryFilter.Year]: StringArrayParams,
  });

  const { query, slug } = useQueryParams<{ query: string; slug: string }>({
    query: StringParam,
    slug: StringParam,
  });

  const { data: hubsData } = useResource(getHubBySlug(slug));
  const {
    data: { subtreeIds },
  } = useResourceRelationship(getHubsSubtree(hubsData.id));

  const { data } = useResource(
    queryOmnisearchThinLectureFiltersRelationship({
      library: 'true',
      scope: 'published',
      query,
      subject_id: subtreeIds,
      ...filters,
    })
  );

  const currentFilters = filters[LibraryFilter.Year] || [];

  const onUpdate = (item) => {
    let updatedFilters = [];

    if (currentFilters.includes(item)) {
      updatedFilters = currentFilters.filter((currentItem) => currentItem !== item);
    } else {
      updatedFilters = [...currentFilters, item];
    }
    change(
      { [LibraryFilter.Year]: updatedFilters.join(',') || undefined },
      { method: 'replace', shallow: true, scroll: true }
    );
    analytics.track('library_year_filter', { release_year: item });
    libLynx.send('trackSearch');
  };

  return (
    <FormControl px={4} as="fieldset">
      <VStack alignItems="flex-start">
        {data?.yearsHeldAt?.map(({ value, label, amount }) => {
          return (
            <Flex w="full" key={value}>
              <Checkbox
                isChecked={currentFilters.includes(value.toString())}
                name={LibraryFilter.Year}
                value={value}
                colorScheme="violet"
                size="lg"
                onChange={() => {
                  onUpdate(value.toString());
                }}
              >
                <Text as="span" textStyle="groteskS">
                  {label} ({amount})
                </Text>
              </Checkbox>
            </Flex>
          );
        })}
      </VStack>
    </FormControl>
  );
};
